export type ErrorCategory = 'network' | 'code';

export interface StandardResponseData {
  code: string;
}

export class DataResponse<TData = StandardResponseData> {
  public message: string = '';
  public statusCode: number = -1;
  public hasNetworkFailure: boolean = false;
  public errorCategory: ErrorCategory | undefined = undefined;
  public data: TData;
  public response: Response;

  constructor(data: TData) {
    this.data = data;
  }
}